import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.styl';
import Popup from '../../../../common/Popup';
import { isDesktop } from '../../../../../utils/mobileHelpers';
import Button from '../../../../Button';
import { targetUserIdSelector } from '../../../../../redux/context/selectors';
import { actions as deleteCardActions } from '../../../../../redux/payment-methods/requests/delete-card-req';

const DeletePopup = ({ itemId, opened, onClose }) => {
  const dispatch = useDispatch();

  const { formatMessage } = useIntl();

  const userId = useSelector(targetUserIdSelector);

  const handleDeleteCard = () => {
    dispatch(
      deleteCardActions.send({
        userId,
        id: itemId,
      }),
    );

    onClose();
  };

  return (
    <Popup
      strictClose
      opened={opened}
      onClose={onClose}
      width={isDesktop() ? 'small' : 'medium'}
      title={formatMessage({
        id: 'profile.payment.removeMessage',
      })}
    >
      <div className={styles.buttonWrapper}>
        <Button
          color="danger"
          className={styles.button}
          onClick={handleDeleteCard}
        >
          {formatMessage({ id: 'common.remove' })}
        </Button>

        <Button color="accent" className={styles.button} onClick={onClose}>
          {formatMessage({ id: 'common.cancel' })}
        </Button>
      </div>
    </Popup>
  );
};
export default DeletePopup;

DeletePopup.propTypes = {
  itemId: PropTypes.number,
  opened: PropTypes.bool,
  onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/Payments/DeletePopup/index.jsx